import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, HeartHandshakeIcon, BrainIcon, UsersIcon, StarIcon } from 'lucide-react';
const AboutPage = () => {
  return <div className="bg-white min-h-screen w-full" data-id="element-103">
      <div className="relative h-64 md:h-80 lg:h-96 overflow-hidden" data-id="element-104">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg" alt="Ayira's Cafe ambiance" className="w-full h-full object-cover" data-id="element-105" />
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/60 to-green-900/60 flex items-center justify-center" data-id="element-106">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-107">
            Our Story
          </h1>
        </div>
      </div>
      <div className="container mx-auto max-w-4xl py-16 px-6" data-id="element-108">
        <div className="text-center mb-12" data-id="element-109">
          <div className="inline-block mb-4 px-6 py-2 bg-green-100 text-green-800 rounded-full font-medium" data-id="element-110">
            About Us
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-semibold mb-4" data-id="element-111">
            Africa's First Neurodivergent Café
          </h2>
          <p className="text-lg text-gray-700" data-id="element-112">
            Serving Purpose, Not Just Plates
          </p>
        </div>
        <div className="prose prose-lg max-w-none" data-id="element-113">
          <p className="lead text-xl text-gray-700" data-id="element-114">
            Ayira's Neuro-Soul Café is a soul-led, sensory-friendly café in
            Nairobi that employs, empowers, and celebrates neurodivergent
            individuals. Named after our founder's daughter, we're not just a
            café—we're a movement for inclusive change.
          </p>
          <div className="my-10 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-115">
            <div className="bg-purple-50 p-6 rounded-lg" data-id="element-116">
              <div className="flex items-center mb-4" data-id="element-117">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4" data-id="element-118">
                  <BrainIcon size={24} className="text-purple-600" data-id="element-119" />
                </div>
                <h3 className="text-xl font-serif font-semibold" data-id="element-120">Our Vision</h3>
              </div>
              <p className="text-gray-700" data-id="element-121">
                A continent where neurodivergent individuals thrive and belong —
                supported by families, schools, and workplaces.
              </p>
            </div>
            <div className="bg-green-50 p-6 rounded-lg" data-id="element-122">
              <div className="flex items-center mb-4" data-id="element-123">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4" data-id="element-124">
                  <HeartHandshakeIcon size={24} className="text-green-600" data-id="element-125" />
                </div>
                <h3 className="text-xl font-serif font-semibold" data-id="element-126">
                  Our Mission
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-127">
                Deliver practical, scalable pathways from diagnosis to
                independence for neurodivergent individuals.
              </p>
            </div>
          </div>
          <h3 className="text-2xl font-serif font-semibold mt-10 mb-6" data-id="element-128">
            Our Core Values
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-129">
            <div className="flex" data-id="element-130">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-131">
                <StarIcon size={24} className="text-amber-600" data-id="element-132" />
              </div>
              <div data-id="element-133">
                <h4 className="text-lg font-medium mb-2" data-id="element-134">Dignity</h4>
                <p className="text-gray-700" data-id="element-135">
                  We believe in the inherent worth and dignity of every
                  individual, regardless of neurological differences.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-136">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-137">
                <StarIcon size={24} className="text-green-600" data-id="element-138" />
              </div>
              <div data-id="element-139">
                <h4 className="text-lg font-medium mb-2" data-id="element-140">Equity</h4>
                <p className="text-gray-700" data-id="element-141">
                  We work to create fair access to opportunities, recognizing
                  that different people need different supports.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-142">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-143">
                <UsersIcon size={24} className="text-purple-600" data-id="element-144" />
              </div>
              <div data-id="element-145">
                <h4 className="text-lg font-medium mb-2" data-id="element-146">Community</h4>
                <p className="text-gray-700" data-id="element-147">
                  We foster a sense of belonging and connection among all who
                  enter our doors.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-148">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-149">
                <BrainIcon size={24} className="text-blue-600" data-id="element-150" />
              </div>
              <div data-id="element-151">
                <h4 className="text-lg font-medium mb-2" data-id="element-152">Neuro-inclusion</h4>
                <p className="text-gray-700" data-id="element-153">
                  We celebrate neurodiversity and create spaces where all
                  neurotypes are welcomed and valued.
                </p>
              </div>
            </div>
          </div>
          <blockquote className="italic border-l-4 border-green-500 pl-4 my-8 text-xl" data-id="element-154">
            "We don't just fill a gap. We redefine what inclusion looks like —
            and prove it's possible."
          </blockquote>
          <h3 className="text-2xl font-serif font-semibold mt-10 mb-6" data-id="element-155">
            Our Approach
          </h3>
          <p data-id="element-156">
            At Ayira's, we take a holistic approach to neurodiversity inclusion.
            We believe that meaningful change happens when we address the entire
            ecosystem around neurodivergent individuals:
          </p>
          <ul data-id="element-157">
            <li data-id="element-158">
              We create employment opportunities that value unique strengths and
              accommodate diverse needs
            </li>
            <li data-id="element-159">
              We train caregivers and educators to better support neurodivergent
              children
            </li>
            <li data-id="element-160">
              We build community awareness and understanding through events and
              workshops
            </li>
            <li data-id="element-161">
              We advocate for systemic changes that promote inclusion at all
              levels of society
            </li>
          </ul>
          <p data-id="element-162">
            Our café serves as both a demonstration of what's possible and a hub
            for these interconnected activities. Every cup of coffee, every meal
            served, and every conversation had contributes to our larger mission
            of creating a more inclusive world.
          </p>
        </div>
        <div className="mt-12 flex flex-col md:flex-row gap-6" data-id="element-163">
          <Link to="/founder" className="flex-1 bg-white border border-purple-200 hover:border-purple-300 rounded-lg p-6 transition-all duration-300 hover:shadow-md" data-id="element-164">
            <h3 className="text-xl font-serif font-semibold mb-2" data-id="element-165">
              Meet Our Founder
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-166">
              Learn about Diana Ayoo and her journey to creating Ayira's
              Neuro-Soul Café.
            </p>
            <div className="flex items-center text-purple-600 font-medium" data-id="element-167">
              Read Diana's story <ArrowRightIcon size={16} className="ml-2" data-id="element-168" />
            </div>
          </Link>
          <Link to="/programs" className="flex-1 bg-white border border-green-200 hover:border-green-300 rounded-lg p-6 transition-all duration-300 hover:shadow-md" data-id="element-169">
            <h3 className="text-xl font-serif font-semibold mb-2" data-id="element-170">
              Our Programs
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-171">
              Discover the impactful programs and initiatives that make Ayira's
              unique.
            </p>
            <div className="flex items-center text-green-600 font-medium" data-id="element-172">
              Explore programs <ArrowRightIcon size={16} className="ml-2" data-id="element-173" />
            </div>
          </Link>
        </div>
      </div>
    </div>;
};
export default AboutPage;